import React from 'react';
import CtaForm from './CtaForm';

const CtafromSection = (props) => {
    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="cta_wrap">
                    <div className="content">
                        <h2>Maximize ROI</h2>
                        <p>Invest in our strategy to acquire, optimize, and sell independent pharmacies for substantial returns.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CtafromSection;